import cn from 'classnames';
import React, { HTMLAttributes, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';

import { MaxPageWidth, type MaxPageWidthClasses } from '~/components/_common/MaxPageWidth';

const sideWidth = '15%';
const innerSideMargin = '4%';
const sidesTopMargin = '15px';

const useStyles = createUseStyles({
  left: {
    width: sideWidth,
    marginRight: innerSideMargin,
    top: sidesTopMargin,
    position: 'sticky',
    height: 'fit-content',
  },
  right: {
    width: sideWidth,
    marginLeft: innerSideMargin,
    top: sidesTopMargin,
    position: 'sticky',
    height: 'fit-content',
  },
  center: {
    flex: 1,
  },
});

export type ThreeColumnLayoutClasses = Partial<ReturnType<typeof useStyles>> & MaxPageWidthClasses;

export type ThreeColumnLayoutProps = HTMLAttributes<HTMLDivElement> & {
  left?: ReactNode;
  right?: ReactNode;
  center?: ReactNode;
  classes?: ThreeColumnLayoutClasses;
};

export const ThreeColumnLayout: React.FC<ThreeColumnLayoutProps> = ({
  left,
  right,
  center,
  classes: classOverrides,
  ...divProps
}) => {
  const classes = useStyles();
  const maxPageWidthClasses: MaxPageWidthClasses = {
    root: classOverrides?.root,
    centered: classOverrides?.centered,
  };

  return (
    <MaxPageWidth classes={maxPageWidthClasses} {...divProps}>
      <div className={cn(classes.left, classOverrides?.left)}>{left}</div>
      <div className={cn(classes.center, classOverrides?.center)}>{center}</div>
      <div className={cn(classes.right, classOverrides?.right)}>{right}</div>
    </MaxPageWidth>
  );
};
